module.exports = __webpack_public_path__ + "static/media/prada.9039713e.jpg";